unit Grid.Settings;

interface

uses
  WEBLib.DBCtrls,
  XData.Web.Dataset;

type
  TOrderInfo = record
    FieldName: string;
    Ascending: Boolean;
  end;
  TSortedItems = array of TOrderInfo;

  TGridSettings = class
  private
    FGrid: TDBTableControl;
    FSortedItems: TSortedItems;
    FFilterText: string;
  public
    constructor Create(AGrid: TDBTableControl; ASortedItems: TSortedItems;
      AFilterText: string);
    destructor Destroy; override;
    property Grid: TDBTableControl read FGrid;
    property SortedItems: TSortedItems read FSortedItems;
    property FilterText: string read FFilterText;
  end;

implementation

{ TGridSettings }

constructor TGridSettings.Create(AGrid: TDBTableControl; ASortedItems: TSortedItems;
  AFilterText: string);
begin
  FGrid := AGrid;
  FSortedItems := ASortedItems;
  FFilterText := AFilterText;
end;

destructor TGridSettings.Destroy;
begin
  inherited;
end;

end.
